import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { AuthShell } from '../../components/admin/AuthShell';
import { Button, Input, useToast } from '../../components/ui';
import { api, errorMessage } from '../../lib/api';

export function AdminLoginPage() {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/admin/auth/login', { email, password });
      window.location.href = '/admin';
    } catch (err) {
      toast.push(errorMessage(err), 'error');
      setLoading(false);
    }
  }

  return (
    <AuthShell
      title="Sign in"
      subtitle="Welcome back to your club"
      footer={
        <>
          New club? <Link to="/admin/signup" className="text-navy-900 underline">Get started</Link>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          type="email"
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
        <Input
          type="password"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        <Button type="submit" disabled={loading} className="w-full">
          {loading ? 'Signing in…' : 'Sign in'}
        </Button>
        <div className="text-center text-sm">
          <Link to="/admin/forgot" className="text-ink-muted underline">
            Forgot password?
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}
